import { render, staticRenderFns } from "./AuthModalComponent.vue?vue&type=template&id=55fb0a6c&"
import script from "./AuthModalComponent.vue?vue&type=script&lang=js&"
export * from "./AuthModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports